"use strict";
/**
 * Created by rouven on 28.03.17.
 */
exports.__esModule = true;
exports["default"] = (function (value) {
    var valueType = typeof value;
    if (valueType === 'string') {
        return value;
    }
    else if (valueType === 'object') {
        return JSON.stringify(value);
    }
    else if (valueType === 'number' || valueType === 'boolean') {
        return String(value);
    }
    else {
        return '';
    }
});
